import type { ComponentProps } from 'react';
import styled from '@emotion/styled';
import type {
  AlignItemsProps,
  BackgroundColorProps,
  BorderColorProps,
  BorderRadiusProps,
  BorderStyleProps,
  BorderWidthProps,
  DisplayProps,
  HeightProps,
  JustifyContentProps,
} from 'styled-system';
import {
  alignItems,
  backgroundColor,
  borderColor,
  borderRadius,
  borderStyle,
  borderWidth,
  display,
  height,
  justifyContent,
} from 'styled-system';

import { CaptionBoldCB1, HeadlineH9 } from '../Typography';

export const BaseLabel = styled(HeadlineH9)<
  BorderRadiusProps &
    BorderStyleProps &
    BorderWidthProps &
    BorderColorProps &
    DisplayProps &
    AlignItemsProps &
    HeightProps &
    BackgroundColorProps &
    JustifyContentProps
>`
  ${borderRadius};
  ${borderStyle};
  ${borderWidth};
  ${borderColor};
  ${display};
  ${alignItems};
  ${justifyContent};
  ${height};
  ${backgroundColor};
`;

export const baseLabelStyles: Partial<ComponentProps<typeof BaseLabel>> = {
  color: 'sys.neutral.text.inverted',
  borderRadius: 'small',
  height: '24px',
  whiteSpace: 'nowrap',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
};

export const SmallBaseLabel = styled(CaptionBoldCB1)<
  BorderRadiusProps &
    DisplayProps &
    AlignItemsProps &
    HeightProps &
    BackgroundColorProps &
    JustifyContentProps
>`
  ${borderRadius};
  ${display};
  ${alignItems};
  ${justifyContent};
  ${height};
  ${backgroundColor};
`;
